import { takeLatest, call, select, put, delay } from "redux-saga/effects"
import { getBifrostJobDetailsApi, getExtractJobDetails } from "../services/bifrostServices"
import {
	GET_EXTRACT_JOB_DETAILS_REQUEST,
	GET_EXTRACT_JOB_DETAILS_REQUEST_SUCCESS,
	GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED,
	GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED_CLEAR,
	GET_BIFROST_JOB_DETAILS_REQUEST,
} from "../types"
import { CLIENT_SIDE_MESSAGES as Messages, clearLocalStorage } from "../utils"
import { clearMultibase } from "../actions/multiAiBase"
import { logoutUser } from "../actions/userActions"
import axiosClient from "axios"
import {
	getBifrostJobDetailsRequestFailed,
	getBifrostJobDetailsRequestReset,
	getBifrostJobDetailsRequestSuccess,
} from "../actions/bifrostActions"

function* getExtractJobDetailsSaga(action) {
	try {
		const result = yield call(getExtractJobDetails, action.payload)

		if (result.status === 200 && result.data.success === true) {
			yield put({
				type: GET_EXTRACT_JOB_DETAILS_REQUEST_SUCCESS,
				payload: result.data.bifrost_job,
			})
		} else {
			yield put({
				type: GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED,
				payload: result,
			})
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put({
					type: GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED,
					payload: Messages.SERVER_ERROR,
				})

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))
				yield delay(3000) //After 3sec message disappear
				yield put({ type: GET_EXTRACT_JOB_DETAILS_REQUEST_FAILED_CLEAR })
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getBifrostJobDetailsSaga(action) {
	try {
		const result = yield call(getBifrostJobDetailsApi, action.payload)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getBifrostJobDetailsRequestSuccess(result.data.bifrost_job))
		} else {
			yield put(getBifrostJobDetailsRequestFailed(result))
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(getBifrostJobDetailsRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))
				yield delay(3000) //After 3sec message disappear
				yield put(getBifrostJobDetailsRequestReset())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

export default function* bifrostExtractJobDetailsSaga() {
	yield takeLatest(GET_EXTRACT_JOB_DETAILS_REQUEST, getExtractJobDetailsSaga)
	yield takeLatest(GET_BIFROST_JOB_DETAILS_REQUEST, getBifrostJobDetailsSaga)
}
